<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header [header]="data.header" [subheader]="data.subheader" />
  </ng-container>

  <ng-container body>
    <email-text [contents]="data.order_summary" size="medium" [bold]="true" />
    <table cellspacing="0" cellpadding="0">
      <ng-container *mailgunFor="let campaign of data.campaigns">
        <tr>
          <td align="left">
            <table cellpadding="0" cellspacing="0">
              <tr>
                <td class="campaign-product" align="left" width="100%">
                  <email-text
                    [contents]="campaign.title"
                    size="small"
                    [bold]="true"
                    vAlign="middle"
                    presetName="paragraph"
                  />
                  <email-text [contents]="campaign.duration" size="small" vAlign="middle" />
                  •
                  <email-text [contents]="campaign.time_to_setup" size="small" vAlign="middle" />
                </td>
              </tr>
            </table>
          </td>
          <td width="4">&nbsp;</td>
          <td nowrap>
            <email-text [contents]="campaign.price" [bold]="true" className="v-align-middle" />
          </td>
        </tr>
      </ng-container>
      <tr>
        <td align="left">
          <table cellpadding="0" cellspacing="0">
            <tr>
              <td class="campaign-product" align="left" width="100%">
                <email-text [contents]="data.total" size="medium" [bold]="true" vAlign="middle" />
              </td>
            </tr>
          </table>
        </td>
        <td width="4">&nbsp;</td>
        <td nowrap>
          <email-text
            [contents]="data.total_price"
            size="medium"
            [bold]="true"
            className="v-align-middle"
          />
        </td>
      </tr>
      <tr>
        <td colspan="3">
          <email-margin [height]="12" />
        </td>
      </tr>
    </table>

    <email-text [contents]="data.body" size="medium" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" />&nbsp;
  </ng-container>
</email-layout>
